import "./SectionOne.css";

import React from "react";

import { Link } from "react-router-dom";

import logo2 from "../../../../shared/imageAssets/logo2.png";

export const SectionOne = () => {
  const handleMoveToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="section-one-container">
      <Link onClick={handleMoveToTop} className="section-one-a" to="/shop">
        Продукти
      </Link>
    </div>
  );
};
